var CONFUSEDCMS = CONFUSEDCMS || {},
    CONFUSEDCARFINANCECALCULATORAPP = CONFUSEDCARFINANCECALCULATORAPP || {},
    Confused = Confused || {},
    newrelic = newrelic || {};

(function(ns, newrelic, $) {
    'use strict';

    // html elements
    ns.Elements = {
        ProviderLowRepresentativeExample: '#hdnProviderLowRepresentativeExample',
        ProviderLowTier1000To1999Percentage: '#hdnProviderLowTier1000To1999Percentage',
        ProviderLowTier2000To2999Percentage: '#hdnProviderLowTier2000To2999Percentage',
        ProviderLowTier3000To4999Percentage: '#hdnProviderLowTier3000To4999Percentage',
        ProviderLowTier5000To7499Percentage: '#hdnProviderLowTier5000To7499Percentage',
        ProviderLowTier7500To19999Percentage: '#hdnProviderLowTier7500To19999Percentage',
        ProviderLowTier20000To36000Percentage: '#hdnProviderLowTier20000To36000Percentage',
        ProviderModerateRepresentativeExample: '#hdnProviderModerateRepresentativeExample',
        ProviderModerateTier1000To1999Percentage: '#hdnProviderModerateTier1000To1999Percentage',
        ProviderModerateTier2000To2999Percentage: '#hdnProviderModerateTier2000To2999Percentage',
        ProviderModerateTier3000To4999Percentage: '#hdnProviderModerateTier3000To4999Percentage',
        ProviderModerateTier5000To7499Percentage: '#hdnProviderModerateTier5000To7499Percentage',
        ProviderModerateTier7500To19999Percentage: '#hdnProviderModerateTier7500To19999Percentage',
        ProviderModerateTier20000To36000Percentage: '#hdnProviderModerateTier20000To36000Percentage',
        ProviderHighRepresentativeExample: '#hdnProviderHighRepresentativeExample',
        ProviderHighTier1000To1999Percentage: '#hdnProviderHighTier1000To1999Percentage',
        ProviderHighTier2000To2999Percentage: '#hdnProviderHighTier2000To2999Percentage',
        ProviderHighTier3000To4999Percentage: '#hdnProviderHighTier3000To4999Percentage',
        ProviderHighTier5000To7499Percentage: '#hdnProviderHighTier5000To7499Percentage',
        ProviderHighTier7500To19999Percentage: '#hdnProviderHighTier7500To19999Percentage',
        ProviderHighTier20000To36000Percentage: '#hdnProviderHighTier20000To36000Percentage',
        CarFinanceCalculatorWidget: '#CarFinanceCalculatorWidget',
        CarFinanceCalculatorStartApplication: '#CarFinanceCalculatorStartApplication',
        CarFinanceCalculatorSpinner: '#CarFinanceCalculatorSpinner',
        CarFinanceCalculatorGetQuote: '#CarFinanceCalculatorGetQuote',
        CalculateButton: '#btnCalculate',
        RecalculateText: '#hdnRecalculateText',
        CalculateErrorHowMuch: '#CalculateErrorHowMuch',
        CalculateErrorHowLong: '#CalculateErrorHowLong',
        ProviderLowSection: '#ProviderLowSection',
        ProviderModerateSection: '#ProviderModerateSection',
        ProviderHighSection: '#ProviderHighSection',
        StartApplicationButton: '#btnStartApplication',
        GetAQuoteButton: '#btnGetAQuote',
        CalculationError: '#CalculationError',
        ProviderLowTitle: '#ProviderLowTitle',
        ProviderModerateTitle: '#ProviderModerateTitle',
        ProviderHighTitle: '#ProviderHighTitle',
        ProviderTitleOnMobile: '#ProviderTitleOnMobile'
    };

    // constants
    ns.Constants = {
        CarFinanceCalculatorWidgetId: 'CarFinanceCalculatorWidget',
        CalculateErrorMessageHowMuch: 'Please select how much you want to borrow',
        CalculateErrorMessageHowLong: 'Please select over how long',
        CarFinanceCalculatorSpinnerTimeout: 1000,
        CarFinanceCalculatorAppName: 'CarFinanceCalculator',
        AprExampleTableTabActive: 'apr-example-table__tab--active',
        ProviderLowTitleOnMobile: 'ProviderLowTitleOnMobile',
        ProviderModerateTitleOnMobile: 'ProviderModerateTitleOnMobile',
        ProviderHighTitleOnMobile: 'ProviderHighTitleOnMobile',
        ProviderLow: 'ProviderLow',
        ProviderModerate: 'ProviderModerate',
        ProviderHigh: 'ProviderHigh'
    };

    // tokens
    ns.Tokens = {
        HowMuch: '[HOWMUCH]',
        HowLong: '[HOWLONG]'
    };

    // utils functions
    ns.Utils = {

        // bind provider low
        BindProviderLow: function (provider) {
            provider.RepresentativeExample($(ns.Elements.ProviderLowRepresentativeExample).val());
            provider.Tier1000To1999Percentage($(ns.Elements.ProviderLowTier1000To1999Percentage).val());
            provider.Tier2000To2999Percentage($(ns.Elements.ProviderLowTier2000To2999Percentage).val());
            provider.Tier3000To4999Percentage($(ns.Elements.ProviderLowTier3000To4999Percentage).val());
            provider.Tier5000To7499Percentage($(ns.Elements.ProviderLowTier5000To7499Percentage).val());
            provider.Tier7500To19999Percentage($(ns.Elements.ProviderLowTier7500To19999Percentage).val());
            provider.Tier20000To36000Percentage($(ns.Elements.ProviderLowTier20000To36000Percentage).val());
        },

        // bind provider moderate
        BindProviderModerate: function (provider) {
            provider.RepresentativeExample($(ns.Elements.ProviderModerateRepresentativeExample).val());
            provider.Tier1000To1999Percentage($(ns.Elements.ProviderModerateTier1000To1999Percentage).val());
            provider.Tier2000To2999Percentage($(ns.Elements.ProviderModerateTier2000To2999Percentage).val());
            provider.Tier3000To4999Percentage($(ns.Elements.ProviderModerateTier3000To4999Percentage).val());
            provider.Tier5000To7499Percentage($(ns.Elements.ProviderModerateTier5000To7499Percentage).val());
            provider.Tier7500To19999Percentage($(ns.Elements.ProviderModerateTier7500To19999Percentage).val());
            provider.Tier20000To36000Percentage($(ns.Elements.ProviderModerateTier20000To36000Percentage).val());
        },

        // bind provider high
        BindProviderHigh: function (provider) {
            provider.RepresentativeExample($(ns.Elements.ProviderHighRepresentativeExample).val());
            provider.Tier1000To1999Percentage($(ns.Elements.ProviderHighTier1000To1999Percentage).val());
            provider.Tier2000To2999Percentage($(ns.Elements.ProviderHighTier2000To2999Percentage).val());
            provider.Tier3000To4999Percentage($(ns.Elements.ProviderHighTier3000To4999Percentage).val());
            provider.Tier5000To7499Percentage($(ns.Elements.ProviderHighTier5000To7499Percentage).val());
            provider.Tier7500To19999Percentage($(ns.Elements.ProviderHighTier7500To19999Percentage).val());
            provider.Tier20000To36000Percentage($(ns.Elements.ProviderHighTier20000To36000Percentage).val());
        },

        // new relic event
        WriteNewRelicPageEvent: function (eventName, eventArgs) {
            eventArgs = eventArgs || {};
            eventArgs = ns.Utils.GetCustomerFromCookies(eventArgs);
            if (newrelic && newrelic.addPageAction !== undefined) {
                newrelic.addPageAction(CONFUSEDCARFINANCECALCULATORAPP.Constants.CarFinanceCalculatorAppName + eventName, eventArgs);
            }
        },

        // get customer from cookies
        GetCustomerFromCookies: function (object) {
            object = object || {};
            var cookies = document.cookie.split(';'),
                xUniqueCustomerSessionIdString = 'X-UniqueCustomerSessionID',
                xUniqueCustomerCookieIdString = 'X-UniqueCustomerCookieID',
                xUniqueCustomerSessionId = '',
                xUniqueCustomerCookieId = '';

            for (var c = 0; c < cookies.length; c++) {
                if (cookies[c].indexOf(xUniqueCustomerSessionIdString) !== -1) {
                    xUniqueCustomerSessionId = cookies[c].split('=')[1];
                }
                if (cookies[c].indexOf(xUniqueCustomerCookieIdString) !== -1) {
                    xUniqueCustomerCookieId = cookies[c].split('=')[1];
                }
            }
            object.XUniqueCustomerSessionIDString = xUniqueCustomerSessionId;
            object.XUniqueCustomerCookieIDString = xUniqueCustomerCookieId;
            return object;
        },

        // show provider low section
        ShowProviderLowSection: function () {
            $(ns.Elements.ProviderLowSection).show();
            $(ns.Elements.ProviderModerateSection).hide();
            $(ns.Elements.ProviderHighSection).hide();

            $(ns.Elements.ProviderLowTitle).addClass(ns.Constants.AprExampleTableTabActive);
            $(ns.Elements.ProviderModerateTitle).removeClass(ns.Constants.AprExampleTableTabActive);
            $(ns.Elements.ProviderHighTitle).removeClass(ns.Constants.AprExampleTableTabActive);
        },

        // show provider moderate section
        ShowProviderModerateSection: function () {
            $(ns.Elements.ProviderLowSection).hide();
            $(ns.Elements.ProviderModerateSection).show();
            $(ns.Elements.ProviderHighSection).hide();

            $(ns.Elements.ProviderLowTitle).removeClass(ns.Constants.AprExampleTableTabActive);
            $(ns.Elements.ProviderModerateTitle).addClass(ns.Constants.AprExampleTableTabActive);
            $(ns.Elements.ProviderHighTitle).removeClass(ns.Constants.AprExampleTableTabActive);
        },

        // show provider high section
        ShowProviderHighSection: function () {
            $(ns.Elements.ProviderLowSection).hide();
            $(ns.Elements.ProviderModerateSection).hide();
            $(ns.Elements.ProviderHighSection).show();

            $(ns.Elements.ProviderLowTitle).removeClass(ns.Constants.AprExampleTableTabActive);
            $(ns.Elements.ProviderModerateTitle).removeClass(ns.Constants.AprExampleTableTabActive);
            $(ns.Elements.ProviderHighTitle).addClass(ns.Constants.AprExampleTableTabActive);
        },

        // number with commas
        NumberWithCommas: function (num) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },

        // number with decimal place
        NumberWithDecimalPlace: function (num) {
            num = parseFloat(num);

            if (num.toString().indexOf('.') === -1) {
                num = num.toFixed(1);
            }

            return num;
        }
    };

    // blank provider
    ns.Provider = function () {
        var self = this;
        self.RepresentativeExample = ko.observable('');
        self.Tier1000To1999Percentage = ko.observable(0.0);
        self.Tier2000To2999Percentage = ko.observable(0.0);
        self.Tier3000To4999Percentage = ko.observable(0.0);
        self.Tier5000To7499Percentage = ko.observable(0.0);
        self.Tier7500To19999Percentage = ko.observable(0.0);
        self.Tier20000To36000Percentage = ko.observable(0.0);
        self.CalculationTierPercentage = ko.observable(0.0);
        self.CalculationMonthlyRepayment = ko.observable(0.0);
        self.CalculationTotalRepayment = ko.observable(0.0);
        self.TokenizedRepresentativeExample = ko.observable('');
    };

    // car finance calculator form
    ns.CarFinanceCalculatorForm = function () {
        var self = this;
        self.ProviderLow = new ns.Provider();
        self.ProviderModerate = new ns.Provider();
        self.ProviderHigh = new ns.Provider();
        self.HowMuch = ko.observable('');
        self.HowLong = ko.observable('');

        // initialise form
        self.Initialise = function () {
            
            // bind to knockout
            ko.applyBindings(self, document.getElementById(ns.Constants.CarFinanceCalculatorWidgetId));

            // bind providers
            ns.Utils.BindProviderLow(self.ProviderLow);
            ns.Utils.BindProviderModerate(self.ProviderModerate);
            ns.Utils.BindProviderHigh(self.ProviderHigh);
        };

        // on How Much
        self.onHowMuch = function () {
            self.ValidateHowMuch();
        };

        // on How Long
        self.onHowLong = function () {
            self.ValidateHowLong();
        };

        // calculate
        self.Calculate = function () {

            // validation
            var isHowMuchValid = self.ValidateHowMuch();
            var isHowLongValid = self.ValidateHowLong();
            if (!isHowMuchValid || !isHowLongValid) {
                return;
            }

            // show spinner
            $(ns.Elements.CarFinanceCalculatorStartApplication).hide();
            $(ns.Elements.CarFinanceCalculatorGetQuote).hide();
            $(ns.Elements.CalculationError).hide();
            $(ns.Elements.CarFinanceCalculatorSpinner).show();

            setTimeout(function () {

                // do calculation
                if (!self.DoCalculation()) {
                    CONFUSEDCARFINANCECALCULATORAPP.Utils.WriteNewRelicPageEvent('CalculationFailed');

                    $(ns.Elements.CarFinanceCalculatorSpinner).hide();
                    $(ns.Elements.CalculationError).show();
                    return;
                }

                // show 'get a quote'
                $(ns.Elements.CalculateButton).html($(ns.Elements.RecalculateText).val());
                ns.Utils.ShowProviderLowSection();
                $(ns.Elements.CarFinanceCalculatorSpinner).hide();
                $(ns.Elements.CarFinanceCalculatorGetQuote).show();

                // scroll to calculator
                $('body').animate({ scrollTop: $(ns.Elements.CarFinanceCalculatorWidget).offset().top });

            }, ns.Constants.CarFinanceCalculatorSpinnerTimeout);

        };

        // validate how much
        self.ValidateHowMuch = function () {
            if (!self.HowMuch()) {
                $(ns.Elements.CalculateErrorHowMuch).text(ns.Constants.CalculateErrorMessageHowMuch);
                return false;
            }

            $(ns.Elements.CalculateErrorHowMuch).text('');
            return true;
        };

        // validate how long
        self.ValidateHowLong = function () {
            if (!self.HowLong()) {
                $(ns.Elements.CalculateErrorHowLong).text(ns.Constants.CalculateErrorMessageHowLong);
                return false;
            }

            $(ns.Elements.CalculateErrorHowLong).text('');
            return true;
        };

        // do calculation
        self.DoCalculation = function () {

            // validate calculation data
            if (!CONFUSEDCARFINANCECALCULATORAPP.Helper.validateCalculationData(self.HowMuch(), self.HowLong(),
                self.ProviderLow, self.ProviderModerate, self.ProviderHigh)) {
                return false;
            }

            // obtain tier percentage for providers
            self.ProviderLow.CalculationTierPercentage(
                CONFUSEDCARFINANCECALCULATORAPP.Helper.obtainTierPercentage(
                self.HowMuch(),
                self.ProviderLow
                ));

            self.ProviderModerate.CalculationTierPercentage(
                CONFUSEDCARFINANCECALCULATORAPP.Helper.obtainTierPercentage(
                self.HowMuch(),
                self.ProviderModerate
                ));

            self.ProviderHigh.CalculationTierPercentage(
                CONFUSEDCARFINANCECALCULATORAPP.Helper.obtainTierPercentage(
                self.HowMuch(),
                self.ProviderHigh
                ));

            // validate tier percentage for providers
            if (self.ProviderLow.CalculationTierPercentage() === null ||
                self.ProviderModerate.CalculationTierPercentage() === null ||
                self.ProviderHigh.CalculationTierPercentage() === null) {
                return false;
            }

            // obtain monthly repayment for providers
            self.ProviderLow.CalculationMonthlyRepayment(
                CONFUSEDCARFINANCECALCULATORAPP.Helper.obtainMonthlyRepayment(
                self.ProviderLow.CalculationTierPercentage(),
                self.HowMuch(),
                self.HowLong()
                ));

            self.ProviderModerate.CalculationMonthlyRepayment(
                CONFUSEDCARFINANCECALCULATORAPP.Helper.obtainMonthlyRepayment(
                self.ProviderModerate.CalculationTierPercentage(),
                self.HowMuch(),
                self.HowLong()
                ));

            self.ProviderHigh.CalculationMonthlyRepayment(
               CONFUSEDCARFINANCECALCULATORAPP.Helper.obtainMonthlyRepayment(
                self.ProviderHigh.CalculationTierPercentage(),
                self.HowMuch(),
                self.HowLong()
                ));

            // obtain total repayment for providers
            self.ProviderLow.CalculationTotalRepayment(
                CONFUSEDCARFINANCECALCULATORAPP.Helper.obtainTotalRepayment(
                self.ProviderLow.CalculationMonthlyRepayment(),
                self.HowLong()
                ));

            self.ProviderModerate.CalculationTotalRepayment(
                CONFUSEDCARFINANCECALCULATORAPP.Helper.obtainTotalRepayment(
                self.ProviderModerate.CalculationMonthlyRepayment(),
                self.HowLong()
                ));

            self.ProviderHigh.CalculationTotalRepayment(
                CONFUSEDCARFINANCECALCULATORAPP.Helper.obtainTotalRepayment(
                self.ProviderHigh.CalculationMonthlyRepayment(),
                self.HowLong()
                ));

            // obtain tokenized representative example
            self.ProviderLow.TokenizedRepresentativeExample(
                CONFUSEDCARFINANCECALCULATORAPP.Helper.obtainTokenizedRepresentativeExample(
                self.ProviderLow.CalculationTierPercentage(),
                self.ProviderLow.CalculationMonthlyRepayment(),
                self.ProviderLow.CalculationTotalRepayment(),
                self.HowMuch(),
                self.HowLong(),
                self.ProviderLow.RepresentativeExample()
                ));

            self.ProviderModerate.TokenizedRepresentativeExample(
                CONFUSEDCARFINANCECALCULATORAPP.Helper.obtainTokenizedRepresentativeExample(
                self.ProviderModerate.CalculationTierPercentage(),
                self.ProviderModerate.CalculationMonthlyRepayment(),
                self.ProviderModerate.CalculationTotalRepayment(),
                self.HowMuch(),
                self.HowLong(),
                self.ProviderModerate.RepresentativeExample()
                ));

            self.ProviderHigh.TokenizedRepresentativeExample(
                CONFUSEDCARFINANCECALCULATORAPP.Helper.obtainTokenizedRepresentativeExample(
                self.ProviderHigh.CalculationTierPercentage(),
                self.ProviderHigh.CalculationMonthlyRepayment(),
                self.ProviderHigh.CalculationTotalRepayment(),
                self.HowMuch(),
                self.HowLong(),
                self.ProviderHigh.RepresentativeExample()
                ));

            // log mi
            CONFUSEDCARFINANCECALCULATORAPP.submitCalculation(
                self.ProviderLow,
                self.ProviderModerate,
                self.ProviderHigh,
                self.HowMuch(),
                self.HowLong()
                );

            return true;
        };

        // on Provider Low Title
        self.onProviderLowTitle = function () {
            ns.Utils.ShowProviderLowSection();
            CONFUSEDCARFINANCECALCULATORAPP.submitProvider(ns.Constants.ProviderLow, false);
        };

        // on Provider Moderate Title
        self.onProviderModerateTitle = function () {
            ns.Utils.ShowProviderModerateSection();
            CONFUSEDCARFINANCECALCULATORAPP.submitProvider(ns.Constants.ProviderModerate, false);
        };

        // on Provider High Title
        self.onProviderHighTitle = function () {
            ns.Utils.ShowProviderHighSection();
            CONFUSEDCARFINANCECALCULATORAPP.submitProvider(ns.Constants.ProviderHigh, false);
        };

        // provider title selected on mobile
        $(ns.Elements.ProviderTitleOnMobile).change(function () {
            switch ($(ns.Elements.ProviderTitleOnMobile).val()) {
                case ns.Constants.ProviderLowTitleOnMobile:
                    ns.Utils.ShowProviderLowSection();
                    CONFUSEDCARFINANCECALCULATORAPP.submitProvider(ns.Constants.ProviderLow, true);
                    break;
                case ns.Constants.ProviderModerateTitleOnMobile:
                    ns.Utils.ShowProviderModerateSection();
                    CONFUSEDCARFINANCECALCULATORAPP.submitProvider(ns.Constants.ProviderModerate, true);
                    break;
                case ns.Constants.ProviderHighTitleOnMobile:
                    ns.Utils.ShowProviderHighSection();
                    CONFUSEDCARFINANCECALCULATORAPP.submitProvider(ns.Constants.ProviderHigh, true);
                    break;
                default:
                    ns.Utils.ShowProviderLowSection();
                    CONFUSEDCARFINANCECALCULATORAPP.submitProvider(ns.Constants.ProviderLow, true);
            }
        });

        // on Start Application
        $(ns.Elements.StartApplicationButton).click(function (e) {
            e.preventDefault();

            // get link
            var startApplicationLink = self.detokenizeLink($(ns.Elements.StartApplicationButton).attr('href'));

            // log mi
            CONFUSEDCARFINANCECALCULATORAPP.submitClickthrough('startapplication', startApplicationLink);

            // open link
            window.open(startApplicationLink, '_self');
        });


        // on Get A Quote
        $(ns.Elements.GetAQuoteButton).click(function (e) {
            e.preventDefault();

            // get link
            var getAQuoteLink = self.detokenizeLink($(ns.Elements.GetAQuoteButton).attr('href'));

            // log mi
            CONFUSEDCARFINANCECALCULATORAPP.submitClickthrough('getaquote', getAQuoteLink);

            // open link
            window.open(getAQuoteLink, '_self');
        });

        // detokenize link
        self.detokenizeLink = function (link) {
            return link
                .replace(ns.Tokens.HowMuch, self.HowMuch())
                .replace(ns.Tokens.HowLong, self.HowLong());
        };

        // monthly repayment whole number
        self.MonthlyRepaymentWholePart = function (calculation) {
            return ns.Utils.NumberWithCommas(calculation().toFixed(2).toString().split('.')[0]);
        };

        // monthly repayment fraction number
        self.MonthlyRepaymentDecimalPart = function (calculation) {
            return calculation().toFixed(2).toString().split('.')[1];
        };

        // tier percentage format
        self.TierPercentageFormat = function (calculation) {
            return ns.Utils.NumberWithDecimalPlace(calculation());
        };

    };

    // set up car finance calculator form
    if ($(ns.Elements.CarFinanceCalculatorWidget).length > 0) {

        var carFinanceCalculatorForm = new CONFUSEDCARFINANCECALCULATORAPP.CarFinanceCalculatorForm();
        carFinanceCalculatorForm.Initialise();

    }

})(CONFUSEDCARFINANCECALCULATORAPP, newrelic, jQuery);



